/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_State_RegisteredInputs */



/**
* | output |
* | --- |
* | "Registered" |
*
* @param {Player_State_RegisteredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const player_state_registered = /** @type {((inputs?: Player_State_RegisteredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_State_RegisteredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inscrit")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inscrito")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Inscrito")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iscritto")
	return /** @type {LocalizedString} */ ("Registered")
});